module.exports = __webpack_public_path__ + "static/premios@2x-5d9da5de9ad37c34fade7c705f2fad35.webp";